/**
 * Subtle repeating dot-grid pattern background.
 * Renders as an absolutely-positioned layer — parent must be `relative`.
 */

interface SpotlightIconPatternProps {
  color?: string;
  opacity?: number;
}

function buildPatternSvg(color: string): string {
  // 40×40 tile with offset dots in a brick layout
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">` +
    `<circle cx="4" cy="4" r="1.5" fill="${color}"/>` +
    `<circle cx="24" cy="24" r="1.5" fill="${color}"/>` +
    `</svg>`
  );
}

export function SpotlightIconPattern({ color = "#94a3b8", opacity = 0.18 }: SpotlightIconPatternProps) {
  const svg = buildPatternSvg(color);
  const encoded = `data:image/svg+xml,${encodeURIComponent(svg)}`;

  return (
    <div
      className="absolute inset-0 pointer-events-none"
      style={{
        backgroundImage: `url("${encoded}")`,
        backgroundRepeat: "repeat",
        opacity,
      }}
      aria-hidden="true"
    />
  );
}
